import { useState } from "react"
import { useGetLocationQuery } from "../../../app/data/location/locationApi"

export const useGetCityFromGeolocation = () => {
  const { data, isLoading } = useGetLocationQuery()
  const [city, setCity] = useState<string>("")

  const getCity = () =>
    isLoading || !data || !data.city
      ? getAlternativeCity()
      : Promise.resolve(setCity(data.city))

  //если город не российский, то берем город по координатам
  const getAlternativeCity = async (): Promise<void> => {
    try {
      const position = await getPosition()
      const cityName = await fetchCityName(position)
      setCity(cityName)
    } catch (error) {
      console.warn(`Ошибка геолокации: ${error}`)
    }
  }

  const getPosition = (): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: 3600,
        maximumAge: 1000,
      })
    })
  }

  const fetchCityName = async (
    position: GeolocationPosition,
  ): Promise<string> => {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${position.coords.latitude}&lon=${position.coords.longitude}`,
    )
    const data = await response.json()
    return (
      data.address.city || data.address.town || data.address.village || "Москва"
    )
  }

  return { getCity, city, isLoading }
}
